import { render, staticRenderFns } from "./PaySlipAnnexPage.vue?vue&type=template&id=5a892286&"
import script from "./PaySlipAnnexPage.vue?vue&type=script&lang=js&"
export * from "./PaySlipAnnexPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports